module.exports = __webpack_public_path__ + "media/images/icon-tv-6c6e61d8a8842fdf1e84b1e4b44454cb.svg";